import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

export default function FarmInsightsInfoPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('insights');

  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="page-content">
        <section className="farm-insights-showcase">
          <div className="container">
            <div className="farm-insights-header">
              <h2 className="section-title">Smart Farm Insights</h2>
              <p className="section-subtitle">स्मार्ट कृषि जानकारी</p>
            </div>

            <div className="insights-tabs" data-testid="insights-tabs">
              <button
                className={`insights-tab ${activeTab === 'insights' ? 'active' : ''}`}
                onClick={() => setActiveTab('insights')}
                data-testid="tab-insights"
              >
                Farm Insights (Free)
              </button>
              <button
                className={`insights-tab ${activeTab === 'premium' ? 'active' : ''}`}
                onClick={() => setActiveTab('premium')}
                data-testid="tab-premium"
              >
                Premium Features
              </button>
            </div>

            {activeTab === 'insights' && (
              <div className="insights-tab-content">
                <p className="insights-tagline">
                  Make data-driven farming decisions with real-time soil health, crop monitoring, market prices & AI recommendations
                </p>
                <p className="insights-tagline-hi">
                  वास्तविक समय मिट्टी स्वास्थ्य, फसल निगरानी, बाजार मूल्य और AI सिफारिशों के साथ डेटा-आधारित खेती निर्णय लें
                </p>

                <div className="farm-services-grid">
                  <div className="farm-service-card soil-service">
                    <div className="service-icon-wrapper"><div className="service-icon soil-icon">🌱</div></div>
                    <h3>Soil Health Analysis</h3>
                    <p className="service-subtitle">मिट्टी स्वास्थ्य विश्लेषण</p>
                    <ul className="service-features">
                      <li>pH Level Monitoring</li>
                      <li>Organic Carbon %</li>
                      <li>Nitrogen Content</li>
                      <li>Location-based Data</li>
                    </ul>
                    <div className="service-badge">Real-time Data</div>
                  </div>
                  <div className="farm-service-card ndvi-service">
                    <div className="service-icon-wrapper"><div className="service-icon ndvi-icon">🛰️</div></div>
                    <h3>Crop Health (NDVI)</h3>
                    <p className="service-subtitle">फसल स्वास्थ्य निगरानी</p>
                    <ul className="service-features">
                      <li>Satellite Monitoring</li>
                      <li>Vegetation Index</li>
                      <li>Health Status Alerts</li>
                      <li>NASA Technology</li>
                    </ul>
                    <div className="service-badge">Satellite Powered</div>
                  </div>
                  <div className="farm-service-card market-service">
                    <div className="service-icon-wrapper"><div className="service-icon market-icon">💰</div></div>
                    <h3>Live Market Prices</h3>
                    <p className="service-subtitle">लाइव बाजार मूल्य</p>
                    <ul className="service-features">
                      <li>Mandi Prices</li>
                      <li>Multiple Crops</li>
                      <li>Price Trends</li>
                      <li>Best Selling Time</li>
                    </ul>
                    <div className="service-badge">Updated Daily</div>
                  </div>
                  <div className="farm-service-card ai-service">
                    <div className="service-icon-wrapper"><div className="service-icon ai-icon">🤖</div></div>
                    <h3>AI Recommendations</h3>
                    <p className="service-subtitle">AI सिफारिशें</p>
                    <ul className="service-features">
                      <li>Irrigation Advice</li>
                      <li>Fertilizer Tips</li>
                      <li>Pest Management</li>
                      <li>Crop Planning</li>
                    </ul>
                    <div className="service-badge">AI Powered</div>
                  </div>
                </div>

                <div className="farm-insights-cta">
                  <div className="cta-content">
                    <h3>All Farm Insights Features Are FREE!</h3>
                    <p>No premium subscription needed - available to all registered users</p>
                    <p className="hindi-text">कोई प्रीमियम सदस्यता की आवश्यकता नहीं - सभी पंजीकृत उपयोगकर्ताओं के लिए उपलब्ध</p>
                  </div>
                  <button className="btn-primary cta-btn" onClick={() => navigate('/auth')}>
                    Sign Up Now & Access Farm Insights
                  </button>
                </div>
              </div>
            )}

            {activeTab === 'premium' && (
              <div className="insights-tab-content">
                <div className="premium-features-grid">
                  <div className="premium-feature-card">
                    <div className="premium-icon soil">🌱</div>
                    <h3>Soil & Fertilizer Analysis</h3>
                    <p className="hindi-text">मिट्टी और उर्वरक विश्लेषण</p>
                    <p>Upload soil test reports or photos. AI analyzes NPK levels, pH, soil type and recommends best fertilizers and suitable crops for your land.</p>
                  </div>
                  <div className="premium-feature-card">
                    <div className="premium-icon weather">☁️</div>
                    <h3>Weather Forecast + Pest Alerts</h3>
                    <p className="hindi-text">मौसम पूर्वानुमान + कीट अलर्ट</p>
                    <p>Get 7-day localized weather forecast with rain probability, temperature, and pest outbreak risk alerts to protect your crops.</p>
                  </div>
                  <div className="premium-feature-card">
                    <div className="premium-icon consultation">📹</div>
                    <h3>3 Video/Voice Consultations with Agronomists</h3>
                    <p className="hindi-text">कृषि विशेषज्ञों के साथ 3 वीडियो/वॉयस परामर्श</p>
                    <p>Get personalized farming support through video or voice calls with highly qualified agronomists.</p>
                  </div>
                  <div className="premium-feature-card">
                    <div className="premium-icon expert">📞</div>
                    <h3>24/7 Phone Support</h3>
                    <p className="hindi-text">24/7 फोन सहायता</p>
                    <p>Priority phone support for urgent farming queries. Call <strong>9599153699</strong> anytime for immediate assistance.</p>
                  </div>
                </div>

                <div className="premium-cta">
                  <h3>All Premium Features for just ₹499/month!</h3>
                  <p className="hindi-text">सिर्फ ₹499/महीने में सभी प्रीमियम सुविधाएं!</p>
                  <button className="btn-primary" onClick={() => navigate('/auth')}>
                    Start Premium Trial
                  </button>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
}
